import React from 'react';
import './Greeting.scss';
import Breadcrumb from '../../components/common/Breadcrumb';
import { useLocation, useNavigate } from 'react-router-dom';

const Greeting = () => {
  const navigate = useNavigate();
  const location = useLocation(); // 현재 경로 정보를 가져옴

  // 경로 일치 여부를 확인하는 함수
  const isActive = (path) => (location.pathname === path ? 'active' : '');

  return (
    <div className="sub-page greeting">
      <section className="sub-visual about">
        <div className="container">
          <span className="sub-title">COMPANY INFO</span>
          <h1>인사말</h1>
          <p>산업용 · 특수 · 양면 테이프 전문 제조</p>
        </div>
      </section>

      <Breadcrumb />

      <nav className="category-nav">
        <div className="container">
          <div className="nav-inner">
            <button className={isActive('/about/greeting')} onClick={() => navigate('/about/greeting')}>
              인사말
            </button>
            <button className={isActive('/about/map')} onClick={() => navigate('/about/map')}>
              찾아오시는 길
            </button>
            <button className={isActive('/about/intro')} onClick={() => navigate('/about/intro')}>
              회사소개서
            </button>
          </div>
        </div>
      </nav>

      <div className="container content-wrap">
        <div className="greeting-main">
          <div className="text-area">
            <h2 className="main-title">
              안녕하십니까. <br />
              <strong>베스트트레이딩</strong>입니다.
            </h2>

            <div className="paragraph-wrap">
              <p className="lead">
                저희는 20년 이상 산업용 테이프 및 점착 제품 분야에 집중하며 <br />
                현장에서 검증된 경험과 노하우를 축적해온 기업입니다.
              </p>

              <p className="desc">
                오랜 업력을 바탕으로 안정적인 품질과 일관된 생산 기준을 유지하며, 고객의 다양한 요구에 맞춘 최적의
                솔루션을 제공하고 있습니다. 베스트트레이딩은 단순한 제품 공급을 넘어 고객의 생산성과 효율을 함께
                고민하는 파트너로서 신속한 대응과 책임 있는 서비스로 신뢰를 쌓아가고 있습니다.
              </p>

              <p className="desc">
                앞으로도 끊임없는 기술 개선과 품질 혁신을 통해 변화하는 산업 환경에 능동적으로 대응하며, 고객과 함께
                성장하는 기업이 되겠습니다.
              </p>

              <p className="desc">감사합니다.</p>
            </div>

            <div className="ceo-signature-block">
              <div className="sign-info">
                <span>베스트트레이딩 대표이사</span>
                <strong>오 장 덕</strong>
              </div>
              {/* 궁서체/서예 느낌의 정갈한 한글 사인 */}
              <div className="ceo-stamp-sign">오장덕</div>
            </div>
          </div>

          {/* [수정] placeholder 제거 후 ce.png 이미지 추가 */}
          <div className="image-area">
            <div className="img-frame">{/* background-image 스타일로 ce.png 적용 예정 */}</div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Greeting;
